import { startAppListening } from "./listenerMiddleware";

const buildUrlMiddleware = (window: Window) => {
  startAppListening({
    predicate: (_action, currentState, previousState) => {
      const slideIndex =
        currentState.deck.slideIndex != previousState.deck.slideIndex;
      const deck = currentState.route.deck != previousState.route.deck;

      return slideIndex || deck;
    },
    effect: async (_action, listenerApi) => {
      const state = listenerApi.getState();
      const page = state.deck.slideIndex;
      const deck = state.route.deck;

      const originalLocation = window.location.toString();

      const url = new URL(originalLocation);
      url.searchParams.set("page", page.toString());
      url.searchParams.set("deck", deck.toString());

      const newLocation = url.toString();

      if (newLocation !== originalLocation) {
        window.history.pushState(null, "", newLocation);
      }
    },
  });
};

export default buildUrlMiddleware;
